import {PredefinedPIXIAnchorPoint} from "../PredefinedPIXIAnchorPoint";
import {CustomSpineAnimation} from "./CustomSpineAnimation";
import {Utils} from "./Utils";

export class WinInfoAnimation extends CustomSpineAnimation {

    private static readonly ANIMATION_CONFIG = {
        NAME: "winInfo",
        STATES: {
            BUST: "bust",
            BUST_IDLE: "bust_idle",
            CHECKING_BLACKJACK: "checkingBlackjack",
            NO_WIN: "noWin",
            NO_WIN_IDLE: "noWin_idle",
            PUSH: "push",
            PUSH_IDLE: "push_idle",
            YOU_WIN: "youWin",
            YOU_WIN_IDLE: "youWin_idle",
            IDLE_EMPTY: "idle_empty",
        },
        SLOT_CONTAINERS: {
            WIN_VALUE: "winValueFrame",
        },
    };

    private readonly WIN_VALUE_TEXT_STYLE = {
        fontSize: 21,
        fontFamily: "RobotoRegular",
        fill: "#ffff99",
    };

    private readonly WIN_VALUE_POSITION = new PIXI.Point(0, -17);

    private winValue: PIXI.Text;

    constructor() {
        super(WinInfoAnimation.ANIMATION_CONFIG.NAME);
        this.createAndAddWinInfoTextValue();
        // if (!(window as any).dupa) {
        //     (window as any).dupa = 1;
        // } else {
        //     (window as any)["dupa" + (window as any).dupa] = this;
        //     (window as any).dupa++;
        // }
    }

    public playBust(): void {
        this.play(WinInfoAnimation.ANIMATION_CONFIG.STATES.BUST);
    }

    public playNoWin(): void {
        this.play(WinInfoAnimation.ANIMATION_CONFIG.STATES.NO_WIN);
    }

    public playPush(winAmount: number): void {
        this.setWinValue(winAmount);
        this.play(WinInfoAnimation.ANIMATION_CONFIG.STATES.PUSH);
    }

    public playYouWin(winAmount: number): void {
        this.setWinValue(winAmount);
        this.play(WinInfoAnimation.ANIMATION_CONFIG.STATES.YOU_WIN);
    }

    public playCheckingBlackjack(): void {
        this.play(WinInfoAnimation.ANIMATION_CONFIG.STATES.CHECKING_BLACKJACK);
    }

    public hide(): void {
        this.play(WinInfoAnimation.ANIMATION_CONFIG.STATES.IDLE_EMPTY);
    }

    private setWinValue(winAmount: number): void {
        this.winValue.text = winAmount.toFixed(Utils.getBetPrecision());
    }

    private createAndAddWinInfoTextValue(): void {
        this.winValue = new PIXI.Text("", this.WIN_VALUE_TEXT_STYLE);
        this.winValue.position = this.WIN_VALUE_POSITION;
        this.winValue.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.winValue.scale.y = -1;
        this.getSlotContainer(WinInfoAnimation.ANIMATION_CONFIG.SLOT_CONTAINERS.WIN_VALUE).addChild(this.winValue);
    }
}



// WEBPACK FOOTER //
// ./src/app/WinInfoAnimation.ts